import { ethers } from 'ethers';
import { CONTRACT_ADDRESSES } from '../config/config';
import { useBalance } from 'wagmi';
import { useEffect, useRef } from 'react';

export const useChainBalance = (address: string) => {
  const prevBalanceRef = useRef<string | undefined>(undefined);
  
  const { data: balanceData, isLoading, error } = useBalance({
    address: address as `0x${string}`,
    token: CONTRACT_ADDRESSES.usdc as `0x${string}`,
    chainId: 1,
    query: {
      enabled: !!address,
      refetchInterval: false,  // 禁用自动轮询
      staleTime: 10 * 60 * 1000,  // 优化：增加到10分钟缓存
      gcTime: 20 * 60 * 1000,  // 20分钟后清理缓存
      refetchOnWindowFocus: false,  // 窗口聚焦时不重新获取
      refetchOnMount: false,  // 组件挂载时不重新获取
      refetchOnReconnect: false  // 网络重连时不重新获取
    }
  });

  // 将原始值转换为 USDC（6位小数）
  const balance = balanceData?.value 
    ? ethers.utils.formatUnits(balanceData.value, 6)  // USDC 使用 6 位小数
    : prevBalanceRef.current || '0';  // 使用上一次的有效余额

  useEffect(() => {
    if (balanceData?.value) {
      const formattedBalance = ethers.utils.formatUnits(balanceData.value, 6);
      if (formattedBalance !== '0') {  // 只在余额不为0时更新
        prevBalanceRef.current = formattedBalance;
      }
    }
  }, [balanceData?.value]);

  return {
    balance,
    isLoading,
    error,
    rawBalance: balanceData?.value?.toString()  // 添加原始余额用于调试
  };
};

export const formatBalance = (balanceData: any): string => {
  if (!balanceData?.value) return '0';
  const balance = ethers.utils.formatUnits(balanceData.value, 6);
  return balance;
}; 